<template>
  <v-row class="caption" cols="8">
    <v-col class="d-flex align-center justify-center">
      <div>
        <img src="../assets/pin-set.svg" alt="" />
      </div>
      <div class="body-2">
        ：通知オン
      </div>
    </v-col>
    <v-col class="d-flex align-center justify-center">
      <div>
        <img src="../assets/pin-notset.svg" alt="" />
      </div>
      <div class="body-2">
        ：通知オフ
      </div>
    </v-col>
    <v-col class="d-flex align-center justify-center">
      <div>
        <img src="../assets/pin-alert.svg" alt="" />
      </div>
      <div class="body-2">
        ：検知中
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'NotificationIconList'
}
</script>
